import React from 'react'
import ReactDOMServer from 'react-dom/server';
import moment from 'moment'
import '../../../assets/css/a4.css';
import {inWords} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
import HistoryChoser from '../historyChoser'

const TableCustomPadding = () =>(
  <style>
{".preview-a4 .table>tbody>tr>td { padding: 8px;}"}
  </style>
)

export default class InvoiceTrader extends React.Component {

  render() {


        let company = this.props.company
        let invoice = this.props.invoice
        let historyRecords = this.props.history
        let settings = this.props.settings || getUserSettings()
        let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
        let invoice_date = moment(invoice.date).format('D-MM-YYYY')
        let billto_1, billto_2, billFrom
        let place_of_supply
        let shipping_address
        let optionalRow = false
        let minRows = 10
        let table_cols = 16
        let invoice_label = "INVOICE"
        let show_mrp_column = false
        let show_container_unit = false
        let serial = invoice.series_name + invoice.series_counter
        if(document) {
          const s = ReactDOMServer.renderToStaticMarkup(serial)
          document.title = s
        }
        let bankDetails, declartion, tnc
        let purchase_order
        let historySelection
        let settingOptions = settings.options || {}
        let options

        if(settings.invoice_label) {
          invoice_label = <div className="" style={{fontFamily:'serif'}}>
             <span>{settings.invoice_label}</span>
          </div>
        }

        if(settingOptions && settingOptions.show_invoice_history) {
          historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
        }

        let company_gstin, company_phone
        if(company.gstin) {
          company_gstin = <span>{"GSTIN: " +company.gstin}</span>
        }

        if(typeof company.phone !== "undefined" && company.phone.length > 0) {
          company_phone = <span >{"Ph: " +company.phone}</span>
        }


        if(typeof invoice.client !== "undefined" && invoice.client !== null) {
          place_of_supply = invoice.client.city
          let client_gstin
          let client_phone
          if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
            client_gstin = "GSTIN-"+invoice.client.gstin
          }
          if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
            client_phone = "Ph: " + invoice.client.phone
          }
          if(!invoice.client.same_as_biiling) {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.shipping_address}
              </div>
              <div className="gray">
              <span className="gray">
              {invoice.client.shipping_city}
              </span>
              <span className="gray">
              {" "+invoice.client.shipping_state} {" "+invoice.client.shipping_pin}
              </span>
              <span className="gray">
              {invoice.client.shipping_state_code.length > 0 ? " State Code: "+invoice.client.shipping_state_code: ""}
              </span>

              </div>
              <div className="gray">
                  {invoice.client.shipping_state}-{invoice.client.shipping_pin}
              </div></div>
          }
          else {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div className="gray">
                <span className="gray">
                {invoice.client.city}
                </span>
                <span className="gray">
                {" "+invoice.client.state} {" "+invoice.client.pin}
                </span>
              <span className="gray">
              {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
              </span>

              </div>
              </div>
          }

          billto_1 =  <div className="row"><div className="col-xs-12">
            <div className="">
            <div>Bill To</div>
              <div className="gray">
                  <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div>
                <span className="gray">
               {invoice.client.city} {" "+invoice.client.state}
                </span>
                <span className="gray">
                {" "+invoice.client.pin}
                </span>
                <span className="gray">
                {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
                </span>
              </div>
              <div>
              </div>
              <div className="gray">
                 {client_gstin}
              </div>
            </div>
          </div></div>

          billto_2 = <div className="row"><div className="col-xs-12">
            <div className="">
            <div>Ship To</div>
              {shipping_address}
            </div>
            <div>
              {client_phone}
            </div>
          </div></div>




        }





        let date_of_supply = <div>Date of Supply: {invoice_date}</div>


        let transportSection

        let transportlabel = invoice.transportlabel, vehicle_number, WAY_BILL_NO
        if(typeof transportlabel !== "undefined" && transportlabel !== null) {

          let t_label_name, t_bill_no, t_lr_no, t_challan_no, t_vehicle_no, t_ship_by, t_transporter_name, t_transporter_id, t_transporter_gstin
          t_bill_no = transportlabel.bill_no
          if (t_bill_no) {
              WAY_BILL_NO = <div className="">
                Way Bill No: {transportlabel.bill_no}
              </div>
          }

          t_label_name = transportlabel.label_name
          if(t_label_name === "way_bill_no") {
            t_label_name = <strong>Way Bill No: </strong>
          }
          else if(t_label_name === "e_sugam_no"){
            t_label_name = <strong>E Sugam No: </strong>
          }
          else if (t_label_name === "eway_bill_no") {
            t_label_name = <strong>EWay Bill No: </strong>
          }
          t_vehicle_no = transportlabel.vehicle_no
          vehicle_number = transportlabel.vehicle_no
          if(typeof vehicle_number !== "undefined" && vehicle_number !== null && vehicle_number.length > 0) {
            vehicle_number = <div className=""><span>Vehicle No: {vehicle_number}</span></div>
          }
          t_challan_no = transportlabel.challan_no
          if(typeof t_challan_no !== "undefined" && t_challan_no !== null && t_challan_no.length > 0) {
            t_challan_no = <span>Challan No:  {t_challan_no}</span>
          }
          t_lr_no = transportlabel.lr_no
          if(typeof t_lr_no !== "undefined" && t_lr_no !== null && t_lr_no.length > 0 ) {
            t_lr_no = <span>LR No:  {t_lr_no}</span>
          }

          t_ship_by = transportlabel.ship_by
          if(typeof t_ship_by !== "undefined" && t_ship_by !== null && t_ship_by.length> 0) {
            t_ship_by = <span>Ship By:  {t_ship_by}</span>
          }
          t_transporter_name = transportlabel.transporter_name
          if(typeof t_transporter_name !== "undefined" && t_transporter_name !== null && t_transporter_name.length > 0) {
            t_transporter_name = <span>Transporter Name:  {t_transporter_name}</span>
          }
          t_transporter_id = transportlabel.transporter_id
          if(typeof t_transporter_id !== "undefined" && t_transporter_id !== null && t_transporter_id.length > 0) {
            t_transporter_id = <span>Transporter ID:  {t_transporter_id}</span>
          }
          t_transporter_gstin = transportlabel.transporter_gstin
          if(typeof t_transporter_gstin !== "undefined" && t_transporter_gstin !== null && t_transporter_gstin.length > 0) {
            t_transporter_gstin = <span>Transporter GSTIN:  {t_transporter_gstin}</span>
          }

          transportSection = <div>
                <div>{WAY_BILL_NO}</div>
                <div>{vehicle_number}</div>
                <div>{t_lr_no}</div>
                <div>{t_challan_no}</div>
                <div>{t_ship_by}</div>
                <div>{t_transporter_name}</div>
                <div>{t_transporter_id}</div>
                <div>{t_transporter_gstin}</div>

          </div>
        }



        let invoiceLabelRow = <tr>
            <td colSpan={12} className="text-center">
              {invoice_label}
            </td>
            <td colSpan={4} className="text-center">
              {this.props.print_type}
            </td>
        </tr>

        let companyAddressRow = <tr>
            <td colSpan={16}>

                <table className="table table-no-borders" style={{border:'none'}}>
                <tbody>
                  <tr>
                      <td className="text-center">
                      <strong>{company.company_name}</strong>
                      </td>
                  </tr>
                  <tr>
                      <td className="text-center">
                      {company.address}
                      </td>
                  </tr>
                  <tr>
                      <td className="text-center">
                      {company.city}, {company.state}, {company.pin}
                      </td>
                  </tr>
                </tbody>
                </table>
            </td>
        </tr>

        let gstinRow =<tr>
          <td colSpan={12} className="text-left">
              <b>{company_gstin}</b>
          </td>
          <td colSpan={4} className="text-left">
              {company_phone}
          </td>
        </tr>

        let invoiceRow=<tr>
            <td colSpan={12} style={{verticalAlign:'middle'}}>
                <strong>
                  INVOICE: {serial}
                </strong>
            </td>
            <td colSpan={4} className="text-left">
                  {transportSection}
                  <div>{date_of_supply}</div>
                  <div>Place of Supply: {place_of_supply}</div>
            </td>
        </tr>


        let clientRow=<tr>

        <td colSpan={9}>
            {billto_1}
        </td>

        <td colSpan={7}>
        {billto_2}
        </td>
        </tr>


        let invoiceItemHeaderRow =<tr className="text-center">
        <td rowSpan={2}>
        S.No
        </td>
        <td rowSpan={2}>
        Description
        </td>
        <td rowSpan={2}>
        HSN
        </td>
        <td rowSpan={2}>
       Qty
        </td>
        <td rowSpan={2}>
        Unit
        </td>
        <td rowSpan={2}>
        Rate
        </td>
        <td rowSpan={2}>
        Total
        </td>
        <td rowSpan={2}>
        Discount
        </td>
        <td rowSpan={2}>
        Value
        </td>
        <td colSpan={2} className="text-center">
        CGST
        </td>
        <td colSpan={2} className="text-center">
        SGST
        </td>
        <td colSpan={2} className="text-center">
        IGST
        </td>
        <td rowSpan={2} >
        Value
        </td>
        </tr>
      let invoiceItemHeaderRow2 = <tr className="text-center">

      <td>
      Rate
      </td>
      <td>
      Amount
      </td>
      <td>
      Rate
      </td>
      <td>
      Amount
      </td>
      <td>
      Rate
      </td>
      <td>
      Amount
      </td>

      </tr>


      let itemsRows, dummyRows = minRows - invoice.saleitem_set.length

      if(invoice.saleitem_set.length > 0) {

        invoice.saleitem_set.sort((a,b)=>{
          return a.tableIndex - b.tableIndex
        })

        itemsRows = invoice.saleitem_set.map((saleitem, index)=>{
          let discountCol, cgstcol, sgstcol, igstcol

          let unit_price = Number(saleitem.selling_basic_rate),
          taxable_price = parseFloat(saleitem.price).toFixed(2),
          item_total = parseFloat(saleitem.total).toFixed(2),
          discount_value = parseFloat(saleitem.discount_value).toFixed(2)

          let before_discount = parseFloat(saleitem.selling_basic_rate * saleitem.quantity).toFixed(2)



          let igst_pct, igst_amount, cgst_pct, cgst_amount


          if(invoice.is_igst){
            igst_pct = saleitem.gst.igst
            igst_amount = parseFloat(saleitem.igst_amount).toFixed(2)
          }
          else {
            cgst_pct = saleitem.gst.cgst
            cgst_amount = parseFloat(saleitem.cgst_amount).toFixed(2)
          }


          return <tr key={index}>
            <td>{saleitem.tableIndex}</td>

            <td>{saleitem.name}</td>
            <td>{saleitem.hsn}</td>
            <td>{Number(saleitem.quantity)}</td>
            <td>{saleitem.unit.primary_unit}</td>
            <td>{unit_price}</td>
            <td>{before_discount}</td>
            <td className="text-right">{discount_value}</td>
            <td className="text-right">{taxable_price}</td>
            <td>{cgst_pct}</td>
            <td className="text-right">{cgst_amount}</td>
            <td>{cgst_pct}</td>
            <td className="text-right">{cgst_amount}</td>
            <td>{igst_pct}</td>
            <td className="text-right">{igst_amount}</td>
            <td className="text-right">{item_total}</td>
        </tr>
        })
      }



      let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0,
       summarySGST=0, summaryTotal=0, summaryCess = 0, summarySpecificCess = 0
      let percentages={cgst:{}, sgst:{}, igst:{}, cess:{}}
      for (var i = 0; i < invoice.saleitem_set.length; i++) {
          const si = invoice.saleitem_set[i]
          summaryQuantity = summaryQuantity + parseFloat(si.quantity)
          summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
          summaryTaxable = summaryTaxable + parseFloat(si.price)
          summaryIGST = summaryIGST + parseFloat(si.igst_amount)
          summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
          summarySGST = summarySGST + parseFloat(si.sgst_amount)
          summaryCess = summaryCess + parseFloat(si.cess_amount) + parseFloat(si.specific_cess_amount)
          summarySpecificCess = summarySpecificCess + parseFloat(si.specific_cess_amount)
          summaryTotal = summaryTotal + parseFloat(si.total)


          const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst, unique_cess_pct = si.cess_percentage
          const igst_s_amount = parseFloat(si.igst_amount)
          const cgst_s_amount = parseFloat(si.cgst_amount)
          const sgst_s_amount = parseFloat(si.sgst_amount)
          const cess_s_amount = parseFloat(si.cess_amount)
          const specific_cess_amount = parseFloat(si.specific_cess_amount)
          const taxable_price = parseFloat(si.price)
          const total = parseFloat(si.total)

          let cgst_percentages = percentages['cgst']

          if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
            let s = cgst_percentages[unique_cgst_pct]

            s.cgst_amount= s.cgst_amount + cgst_s_amount
            s.sgst_amount= s.sgst_amount + sgst_s_amount
            // s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total

          }
          else {
            cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
          }
          percentages['cgst'] = cgst_percentages

          let igst_percentages = percentages['igst']

          if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
            let s = igst_percentages[unique_igst_pct]
            s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total
          }
          else {
            igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
          }

          percentages['igst'] = igst_percentages


          let cess_percentages = percentages['cess']
          if(typeof cess_percentages[unique_cess_pct] !== "undefined") {
             let s = cess_percentages[unique_cess_pct]
             s.cess_amount = s.cess_amount + cess_s_amount

             s.taxable_price = s.taxable_price + taxable_price
             s.total = s.total + total

          }
          else {
            cess_percentages[unique_cess_pct] = {cess_amount:cess_s_amount,
              specific_cess_amount:specific_cess_amount, taxable_price:taxable_price, total:total}
          }

          percentages['cess'] = cess_percentages

      }

      let blankRows =[]
      if(dummyRows >=0) {
        for(var i =0; i<dummyRows; i++)  {
          blankRows.push(<tr>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
              <td style={{padding:5}}></td>
            </tr>)
        }
      }


      let totalRow = <tr>
      <td colSpan={12} rowSpan={8}>
      <ul className="list-inline">
        <li>
        Rupees:
        </li>
        <li>
        {inWords(invoice.total)}
        </li>
      </ul>
      </td>

        <td colSpan={3} className="text-right" style={{verticalAlign:'middle'}}>
          <strong>Total</strong>
        </td>
        <td className="text-right">
        <strong>{summaryTotal}</strong>
        </td>
      </tr>

      let taxableRow = <tr>

      <td colSpan={3} className="text-right" style={{verticalAlign:'middle'}}>
        Total Before Tax
      </td>
      <td className="text-right">
      {summaryTaxable}
      </td>
      </tr>

      let cgstRow, sgstRow, igstRow

      if(invoice.is_igst) {
        cgstRow = <tr>

        <td colSpan={3} className="text-right">
        CGST
        </td>
        <td>
        </td>
        </tr>
        sgstRow = <tr>

        <td colSpan={3} className="text-right">
        SGST
        </td>
        <td>
        </td>
        </tr>

        igstRow = <tr>

         <td colSpan={3} className="text-right">
           IGST
         </td>
         <td className="text-right">
           {summaryIGST}
         </td>
       </tr>

      }
      else {

        cgstRow = <tr>

         <td colSpan={3} className="text-right">
           CGST
         </td>
         <td className="text-right">
           {summaryCGST}
         </td>
       </tr>


       sgstRow = <tr>

         <td colSpan={3} className="text-right">
           SGST
         </td>
         <td className="text-right">
           {summaryCGST}
         </td>
       </tr>

       igstRow = <tr>

        <td colSpan="3" className="text-right">
        IGST
        </td>
        <td>
        </td>
       </tr>

      }


let totalTaxRow = <tr>

<td colSpan={3} className="text-right">
    Total Tax Amount
</td>
<td className="text-right">
  {summaryIGST}
</td>
</tr>

let afterTaxRow = <tr>

<td colSpan={3} className="text-right">
    Total Amount After Tax
</td>
<td className="text-right">
  {invoice.total}
</td>
</tr>


    let roundOffValue= parseFloat(invoice.total) - parseFloat(summaryTotal)

if(roundOffValue >= 0) {
    roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
}
else {
    roundOffValue = parseFloat(roundOffValue).toFixed(2)
}

let roundOffRow = <tr>
  <td className="text-right " colSpan={3}>
  Round Off
  </td>
  <td className="text-right">
    {roundOffValue}
  </td>
</tr>


let bankRow = <tr>

  <td colSpan={9}>
     <div className="text-left">
                <u>Bank Details</u>
     </div>

     <div><div className="row">
         <div className="col-xs-6">Bank Name</div>
         <div className="col-xs-6">{company.bank_name}</div>
         </div>
         <div className="row">
           <div className="col-xs-6">Account No</div>
           <div className="col-xs-6">{company.account_no}</div>
         </div>
         <div className="row">
           <div className="col-xs-6">IFSC</div>
           <div className="col-xs-6">{company.ifsc_code}</div>
         </div>
         <div className="row">
           <div className="col-xs-6">Branch </div>
           <div className="col-xs-6">{company.branch_name}</div>
         </div>

         </div>
  </td>

  <td colSpan={7}>
  </td>
</tr>


let footerRow = <tr>
  <td colSpan={9}>
  <div className="text-left">
             <u>Terms & Conditions</u>
             <div>
<textarea  style={{border:0, width:'100%', resize:'none', padding:0}} defaultValue={settings.invoice_tnc}></textarea>
             </div>

  </div>
  </td>
  <td colSpan={7} className="text-center">
      <div className="space-large-bottom" style={{marginBottom:60}}>For {company.company_name}</div>

      <div>Authorized Signature</div>
  </td>
</tr>




    return   <div style={{position:'relative'}}>
    <div className="hidden-print" style={{position:'absolute', left:0, backgroundColor:'white', zIndex:1}}>
      {historySelection}
    </div>
    <div className="preview-a4" ref={(pdf)=>{this.pdf = pdf}} id="printablePreview">

    <table className="table table-bordered">
      <tbody>
          {invoiceLabelRow}
          {companyAddressRow}
          {gstinRow}
          {invoiceRow}
          {clientRow}
          {invoiceItemHeaderRow}
          {invoiceItemHeaderRow2}
          {itemsRows}
          {blankRows}
          {totalRow}

          {taxableRow}
          {cgstRow}
          {sgstRow}
          {igstRow}

          {totalTaxRow}
          {roundOffRow}
          {afterTaxRow}

          {bankRow}

          {footerRow}

      </tbody>
    </table>
    <div className="text-center" style={{fontSize:'90%'}}>
        {settingOptions.jurisdiction_notes}
    </div>
    </div>
  </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/invoicemill.js